import React from 'react';
import { Stack } from '@mui/material';
import { useCampaignCreationStore } from 'modules/campaign-creation/stores/useCampaignCreationStore';
import { Paths } from 'services/navigation/paths';
import { Header } from 'common/ui/Header';
import { useNavigate } from 'react-router-dom';
import { CampaignType } from 'generated-graphql/types';
import { RadioGroup } from 'common/form';
import { useFormik } from 'formik';
import Yup from 'utils/validation';
import { CampaignCreationNextButton } from 'modules/campaign-creation/components/CampaignCreationNextButton';
import { CampaignCreationCancelButton } from 'modules/campaign-creation/components/CampaignCreationCancelButton';
import { getTitle } from 'modules/campaign-creation/utils/getTitle';

export const CampaignCreationChooseTypeStep: React.FC = () => {
  const navigate = useNavigate();
  const state = useCampaignCreationStore((store) => store.state);
  const campaignId = useCampaignCreationStore((store) => store.campaignId);
  const onChooseTypeSubmit = useCampaignCreationStore(
    (store) => store.onChooseTypeSubmit
  );
  const campaignType = useCampaignCreationStore(
    (store) => store.state?.campaignType
  );

  const outreachType =
    campaignType && campaignType !== CampaignType.EngagementOutreach
      ? campaignType
      : CampaignType.NewCandidateOutreach;

  const formik = useFormik({
    initialValues: {
      campaignType: campaignType
    },
    validationSchema: Yup.object({
      campaignType: Yup.string().required('Choose an option.')
    }),
    onSubmit: (values) => {
      onChooseTypeSubmit({ campaignType: values.campaignType as CampaignType });
    }
  });

  return (
    <>
      <Header
        title="Choose campaign type"
        breadcrumbs={[{ name: 'Campaigns', path: Paths.CAMPAIGNS }]}
        currentBreadcrumb={getTitle(state)}
        onBack={() => navigate(-1)}
      />
      <Stack spacing="40px">
        <RadioGroup
          field={{
            label: 'Message recipients about a specific job?',
            options: [
              { label: 'Yes', value: outreachType },
              {
                label: 'No',
                value: CampaignType.EngagementOutreach
              }
            ]
          }}
          error={!!formik.errors.campaignType}
          errorMessage={formik.errors.campaignType}
          value={formik.values.campaignType}
          onChange={(e) => {
            formik.setFieldValue('campaignType', e as CampaignType);
          }}
        />
        <Stack direction="row" gap="15px">
          <CampaignCreationNextButton
            handleNext={() => formik.handleSubmit()}
          />
          <CampaignCreationCancelButton campaignId={campaignId} />
        </Stack>
      </Stack>
    </>
  );
};
